
/**
 * params required
 * origin: origen de donde se invoca el component
 * action: acción a realizar
 * params: {
 *  idperson: 
 *  idpayroll:
 * }
 */

import { defineComponent, ref, provide, reactive, computed, onMounted, watchEffect } from "vue"
import type { FormInstance, FormRules } from "element-plus";
import { ElNotification } from 'element-plus'
import { useStore } from "vuex";
//components
import ModalAlergyPerson from "@/views/allergies/Modals/AlergyPerson.vue"

//services
import GlobalService from "@/core/services/GlobalService";
import { errManager, showNotification } from "@/core/config/Tools";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import personService from "@/core/services/PersonService";
import { useI18n } from "vue-i18n/index";

export default defineComponent({
    name: "swPersona",
    props: {
        action: {
            type: Number,
            required: true,
            default: 0,
        },
        origin: {
            type: String,
            required: true,
            default: 'default'
        },
        params: {
            type: Object,
            required: true,
            default: { idperson: null, idpayroll: null }
        },
        idinstitution: {
            type: null,
            required: false,
            default: null
        }
    },
    components: { ModalAlergyPerson },
    emits: ["onResponse"],
    setup(props, { emit }) {
        const { t } = useI18n();
        const loader = ref(false)
        const loaderAllergy = ref(false)
        const store = useStore();
        const maxlength = ref(8)
        const minlength = ref(3)
        const inputRef = ref<HTMLInputElement | null>(null);
        const pattern = ref<any>(/^[a-zA-Z0-9]+$/)
        const listAllergy = ref<any>([])
        const swFormRef = ref<FormInstance>()
        const swForm = reactive(<any>{
            doctype: '1',
            docnumber: null,
            stature: null,
            peso: null,
            marital_status: null,
            blood_type: null,
            ocupation: null,
            listAllergy: listAllergy.value
        })
        const rules = reactive<FormRules>({})
        const actionAllergy = ref(1)
        const dialogAlergy = ref(false)
        const selectedDocument = ref<any>(null);

        //provides
        provide("dialogAlergy", dialogAlergy)

        const getDocuments: any = computed<any>(() => {
            return store.getters.currentUser.type_documents;
        })

        const getGender: any = computed<any>(() => {
            return store.getters.currentUser.gender;
        })

        const maritalStatus: any = computed<any>(() => {
            return store.getters.currentUser.marital_status;
        })

        const bloodType: any = computed<any>(() => {
            return store.getters.currentUser.blood_type;
        })

        const getUbigeo: any = computed<any>(() => {
            return store.getters.currentUser.ubigeo;
        })

        const getCountry: any = computed<any>(() => {
            return store.getters.currentUser.country;
        })

        const findDocumentById = (id: number) => {
            const document = getDocuments.value.find((doc: any) => doc.id === id);
            if (document) {
                selectedDocument.value = { ...document }; // Clona el objeto encontrado
            } else {
                selectedDocument.value = null; // Si no se encuentra, lo seteamos a null
            }
        };

        const changeDocType = () => {
            swForm.docnumber = "";
            findDocumentById(swForm.doctype);
            maxlength.value = selectedDocument.value.params
            minlength.value = 3
            pattern.value = /^[a-zA-Z0-9]+$/
            //if (swForm.doctype == "1") {
            //maxlength.value = minlength.value = 8
            //    pattern.value = /^[a-zA-Z0-9]+$/
            //} else {
            //maxlength.value = 13

            //    pattern.value = /^[a-zA-Z0-9]+$/
            //}
            inputRef.value?.focus()
        }

        watchEffect(async () => {
            await getUbigeo;
        })

        const submitForm = async (formEl: FormInstance | undefined) => {
            if (!formEl) return;
            await formEl.validate((valid, fields) => {
                if (valid) {
                    if (props.action == 1)
                        onSave();
                    else
                        onUpdate();
                }
            });
        };

        const onSave = async () => {
            loader.value = true;
            swForm.idinstitution = props.idinstitution;
            await GlobalService.post('payroll/save', swForm)
                .then((res) => {
                    loader.value = false
                    Swal.fire({ icon: res.data.status, title: res.data.title, html: res.data.message})
                    if(res.data?.status == 'success'){
                        swForm.idperson = res.data?.idperson;
                        swForm.idpayroll = res.data?.payroll?.idpayroll;
                    } 
                    emit("onResponse", res.data)
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onUpdate = async () => {
            loader.value = true
            await GlobalService.update('payroll', props.params?.idpayroll, 'update', swForm)
                .then((res) => {
                    loader.value = false;
                    showNotification({title: res.data.title, message: res.data.message, status: res.data.status });
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const oPenDialogAlergy = () => {
            actionAllergy.value = 1
            dialogAlergy.value = true
        }

        onMounted(() => {
            swForm.doctype = "1";
            findDocumentById(swForm.doctype);
            maxlength.value = selectedDocument.value?.params ?? 0
            if (Number(props.action) === 1) {
                getPerson();
            } else {
                getPayrool();
            }
        })

        const getPerson = async () => {
            if ("person" in props.params) {
                Object.assign(swForm, props.params.person)
            }
        }

        const getPayrool = async () => {
            loader.value = true
            let values = ("payroll" in props.params) ? props.params.payroll : props.params

            await GlobalService.get(`api/payroll/${values.idpayroll}`, 'show')
                .then((res) => {
                    Object.assign(swForm, res.data.payroll)
                    loader.value = false
                    getListAllergy()
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        const onResponseAllergy = (values: any) => {
            if (values.status) {
                getListAllergy()
            } else {
                let itemAllergy = {
                    idperson: values.params?.idperson,
                    name: values.params?.name,
                    idseverity: values.params?.idseverity?.id,
                    severityName: values.params?.idseverity?.name,
                    reactions: values.params?.reactions,
                    mstatus: values.params?.mstatus
                }
                listAllergy.value.push(itemAllergy)
            }
        }

        const getListAllergy = async () => {
            loaderAllergy.value = true
            await GlobalService.get(`api/person/${swForm.idperson}`, 'allergys')
                .then((res) => {
                    listAllergy.value = res.data
                    loaderAllergy.value = false
                }).catch(({ response }) => {
                    loaderAllergy.value = false
                    errManager(response)
                })
        }

        const deleteAllergy = async (row: any) => {
            loaderAllergy.value = true
            await GlobalService.delete('allergy', row.id)
                .then((res) => {
                    loaderAllergy.value = false
                    if (res.data.status == 'success') getListAllergy()
                    showNotification({title: res.data.title, message: res.data.message, status: res.data.status});
                }).catch(({ response }) => {
                    loaderAllergy.value = false
                    errManager(response)
                })
        }

        return {
            t,
            loader,
            loaderAllergy,
            swFormRef,
            swForm,
            rules,
            maxlength,
            minlength,
            inputRef,
            pattern,
            actionAllergy,
            listAllergy,
            dialogAlergy,

            //methods
            changeDocType,
            getDocuments,
            getGender,
            getUbigeo,
            maritalStatus,
            bloodType,
            getCountry,
            submitForm,
            onSave,
            onUpdate,
            oPenDialogAlergy,
            onResponseAllergy,
            getListAllergy,
            deleteAllergy
        }

    },
})
